import React, { useEffect } from "react";
import { Box } from "@mui/material";
import { MapContainer, TileLayer } from "react-leaflet";
import { GeozoneDrawing } from "./Geozone-drawing";
import { useStore } from "../../../hooks/useStore";

export function GeozoneMap() {
    const { geozones } = useStore();

    useEffect(() => {
        geozones.subscribeOnEvents();
        
        return geozones.unsubscribeFromEvents;
    }, []);

    return (
        <Box className="map__wrap_fullheight">
            <MapContainer zoom={13} center={[55.751, 37.643]} className="map" attributionControl={false} whenCreated={geozones.initMap}>
                <TileLayer
                    url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                />
                <GeozoneDrawing />
            </MapContainer>
        </Box>
    );
}
